module.exports = __webpack_public_path__ + "img/pestanas-1.9e312a41.svg";